import { Component, OnInit, Input } from '@angular/core';
import { RadicationSSService } from '../../service/radicationSS/radicationSS.service';
import { RadicationSS } from '../../class/radicationSS';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { ActivatedRoute } from '@angular/router';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-radications-ss',
  templateUrl: './radications-ss.component.html',
  styleUrls: ['./radications-ss.component.scss']
})
export class RadicationsSSComponent implements OnInit {
    @Input() gestionSac: any;

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public radicationSSs: RadicationSS[];
    public selectRadicationSS: RadicationSS;
    public radicationSSID: Number = 0;
    public modNew = false;
    public modView = false;
    public openRadicationSS = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public showFilter: boolean;
    public filters: {key: string, value: string}[];
    public params_id_radicationSS: number;

    public modExportDialog: boolean;
    public form4: FormGroup;
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;
    public apiUrl = config.API_ROOT;

    public es: any;
    public loading: boolean;

    public form3: FormGroup;
    public company_id_filter: AbstractControl;
    public created_by_id_filter: AbstractControl;
    public candidate_id_filter: AbstractControl;
    public optionsSelectionTramite: any[];

    public first = 0;

    constructor(
        public radicationSSService: RadicationSSService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        private route: ActivatedRoute,
        public activatedRoute: ActivatedRoute,
        public translate: TranslateService,
        public fb: FormBuilder
        ) {

            this.loading = false; 
            this.es = calendarES();
            this.optionsSelectionTramite = [];            
            this.optionsSelectionTramite.push({label: 'Inclusión EPS', value: '116'}); 
            this.optionsSelectionTramite.push({label: 'Traslado EPS', value: '117'}); 
            //this.optionsSelectionTramite.push({label: 'Inclusión CCF', value: 'Inclusión CCF'});36,108
            this.optionsSelectionTramite.push({label: 'Ausentismo', value: '115'});
            this.optionsSelectionTramite.push({label: 'Incapacidades', value: '118'});
            this.optionsSelectionTramite.push({label: 'Paz y Salvo', value: '13'});
            this.optionsSelectionTramite.push({label: 'Afiliación Fonredes', value: '111'});
            this.optionsSelectionTramite.push({label: 'Proceso Disciplinario', value: '73'});
            this.optionsSelectionTramite.push({label: 'Solicitud devol aportes Fonredes', value: '112'});
            this.optionsSelectionTramite.push({label: 'Solicitud prestamo Fonredes', value: '113'});
            this.optionsSelectionTramite.push({label: 'Modificación de Cuota Fonredes', value: '114'});
           
            this.form3 = fb.group({
                'company_id_filter': [''],
                'created_by_id_filter': [''],
                'candidate_id_filter': ['']
            });
            this.company_id_filter = this.form3.controls['company_id_filter'];
            this.created_by_id_filter = this.form3.controls['created_by_id_filter'];
            this.candidate_id_filter = this.form3.controls['candidate_id_filter'];

            this.form4 = fb.group({
                'f4_date_start': ['', [Validators.required]],
                'f4_date_end': ['', [Validators.required]],
            });
            this.f4_date_start = this.form4.controls['f4_date_start'];
            this.f4_date_end = this.form4.controls['f4_date_end'];

            this.modExportDialog = false;
            this.loading = false;
        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        this.sort = '-id';

        //this.getRadicationSSs();
        if (this.route.snapshot.url[0].path !== 'gestionSACs') {
            this.showFilter = true;
        } else {
            this.showFilter = false;
        }

        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_radicationSS']) {
                this.params_id_radicationSS = Number(params['id_radicationSS']);
                const filters = [];
                filters.push({key: 'id-in', value: String(this.params_id_radicationSS)});
                this.getRadicationSSsById(this.query, filters);
            } //else {
                //this.getRadicationSSs();
            //}
        });
    }
    
    public loadRadicationSSsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';

        this.getRadicationSSs(event.globalFilter);

    }

    public getRadicationSSs(query?: string) {
        this.radicationSSService.getRadicationSS(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.radicationSSs = response.json().data;
                this.changeLabelRadications();
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }
    getRadicationSSsById(query?: string, filters?: any[]) {
        this.loading = true;
        this.radicationSSService.getRadicationSS(this.page, this.per_page, this.sort, this.query, filters).toPromise().then(
            response => {
                this.loading = false;
                this.edit(response.json().data[0]);
            },
            error => {
                this.loading = false;
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }
    public newRadicationSS() {
        this.modNew = !this.modNew;
        this.selectRadicationSS = null;
    }

    public savedRadicationSS(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectRadicationSS = null;
        this.modNew = false;
        // this.getRadicationSSs();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public cancelRadicationSS (res) {
        this.selectRadicationSS = null;
        this.modNew = false;
        this.modView = false;
        // this.getRadicationSSs();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public edit(radicationSS: RadicationSS) {
        this.modNew = true;
        this.selectRadicationSS = radicationSS;
    }

    public view(radicationSS: RadicationSS) {
        this.openRadicationSS = true;
        this.selectRadicationSS = radicationSS;
        this.radicationSSID = radicationSS.id;
        this.modView = true;
    }

    public deleteDialog(radicationSS: RadicationSS) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(radicationSS);
            }
        });
    }

    public delete(radicationSS: RadicationSS) {
        this.radicationSSService.deleteRadicationSS(radicationSS.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getRadicationSSs();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeRadicationSS(radicationSS: RadicationSS) {
        this.putRadicationSS(radicationSS);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public putRadicationSS(values: RadicationSS) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.radicationSSService.updateRadicationSS(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }


    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/radication-ss/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=id&';

        if (f4_date_start) {
            url = url + 'created_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'created_at-max=' + f4_date_end + '&';
        }

        window.open(url, '_blank');
    } 

    public filter (values) {
        this.page = 1;
        this.first = 0;

        this.filters = [];
        if (this.gestionSac) {
            this.filters.push({key: 'gestion_sac_id-in', value: this.gestionSac.id});
        }
        if (values.company_id_filter) {
            this.filters.push({'key': 'company_id-lk', 'value': values.company_id_filter.id});
        }
        if (values.created_by_id_filter) {
            this.filters.push({'key': 'created_by_id-lk', 'value': values.created_by_id_filter.id});
        }
        if (values.candidate_id_filter) {
            this.filters.push({'key': 'candidate_id-lk', 'value': values.candidate_id_filter.id});
        }
        this.getRadicationSSs();
    }
    public changeLabelRadications()
    {
        this.radicationSSs.forEach(element =>{
            element.labelTramite = element.tramite;
            this.optionsSelectionTramite.forEach(element2 =>{
                 if(element.tramite.indexOf(element2.value) != -1)
                 {
                    element.labelTramite = element2.label;
                 }
                //  else
                //          
            });
         });
    }
    
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/radication-ss/radications-ss.component.ts